
/**
 * Hero scripts.
 *
 * Handles all animations for the hero.
 */

/** Dependencies -------------------------------------------- */

// External

import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin( ScrollTrigger )

// Design system

import { animateGeneralEventName } from '../smooth-scroll'

/** The beef ------------------------------------------------ */

/**
 * Accordion mixin.
 * Provides accordion functionality to single element.
 */
export let mixin = ( { node = null, config = {} } = {} ) => {

    let state = {
        node,
        config,
        backgroundImage : null,
        timeline        : null
    };

    let module = {

        // Setup

        init() {

            state.backgroundImage = node.querySelectorAll( state.config.backgroundImageSelector )

            this.setEventBindings()
            this.setInitialAnimationStates()
        },

        setEventBindings() {
            window.addEventListener( animateGeneralEventName, this.animate.bind( this ) )
        },

        // Main        

        setInitialAnimationStates() {       

            if ( ! state.timeline ) {

                gsap.set( state.backgroundImage, { opacity: 0, scale: 1 } )

                state.timeline = gsap.timeline( { paused: true } )
                    .to( state.backgroundImage, { opacity: 1, scale: 1.02, duration: state.config.inDuration, ease: state.config.inEase } )
            }

        },

        animate() {

            ScrollTrigger.create({
                animation : state.timeline,
                trigger   : node,
                once      : true
            })
        },

        // Handlers

    };

    return module.init()
};

/**
 * Accordion module.
 * Provides an interface to apply accordion functionality to all elements matching a selector.
 */
export default {

    init( { className, config = {} } ) {

        let selected = document.querySelectorAll( `.${className}` )

        if ( ! selected.length ) return

        const defaultConfig = {
            backgroundImageSelector : `.${className}__background-image`,
            inDuration              : 1.25,
            inEase                  : 'power4.easeOut'
        }

        return Array.from( selected ).map(
            ( node, index ) => mixin( { node, config: { ...defaultConfig, ...config, className } } )
        )
    }
}
